export default __webpack_public_path__ + "static/media/firebase.15a28ac4.svg";